"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Blank = function Blank(_ref) {
  var title = _ref.title,
      description = _ref.description,
      width = _ref.width,
      height = _ref.height,
      rest = _objectWithoutProperties(_ref, ["title", "description", "width", "height"]);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    "aria-hidden": !title,
    "aria-labelledby": "BlankTitle BlankDescription",
    height: height,
    preserveAspectRatio: "none",
    role: "img",
    viewBox: "0 0 24 24",
    width: width
  }, rest), /*#__PURE__*/_react["default"].createElement("title", {
    id: "BlankTitle"
  }, title), /*#__PURE__*/_react["default"].createElement("desc", {
    id: "BlankDescription"
  }, description), /*#__PURE__*/_react["default"].createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    transform: "scale(0.75 0.75)",
    d: "M25.191 31.32a6.809 6.809 0 1 1 0-13.618 6.809 6.809 0 0 1 0 13.617zm3.405-6.3v-1.076H25.7V21.05h-1.076v2.894H21.73v1.076h2.895v2.895h1.076V25.02h2.895zM1.424.447l1.052 1.7A.998.998 0 0 0 2 3v2.377H0V3C0 1.921.57.975 1.424.447z",
    fillRule: "nonzero"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    transform: "scale(0.75 0.75)",
    d: "M10 0v2H4V0zm10 0v2h-6V0z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    transform: "scale(0.75 0.75)",
    d: "M24.552 1a2.998 2.998 0 0 1 1.424 2.553V5.93h-2V3.553a.998.998 0 0 0-.476-.852L24.552 1z",
    fillRule: "nonzero"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    transform: "scale(0.75 0.75)",
    d: "M26 14.36h-2V9h2z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    transform: "scale(0.75 0.75)",
    d: "M1.424 24.93A2.998 2.998 0 0 1 0 22.377V20h2v2.377c0 .351.181.67.476.852l-1.052 1.7z",
    fillRule: "nonzero"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    transform: "scale(0.75 0.75)",
    d: "M13 25.377H7v-2h6zM2 15.65H0v-6h2z"
  })));
};

Blank.defaultProps = {
  description: '',
  height: 24,
  title: null,
  width: 24
};
Blank.propTypes = {
  description: _propTypes["default"].string,
  height: _propTypes["default"].number,
  title: _propTypes["default"].string,
  width: _propTypes["default"].number
};
var _default = Blank;
exports["default"] = _default;